import React from 'react';

const SubtractCircle = ({ width = 32, height = 32 }: any) => {
  return (
    <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="16" cy="16" r="16" fill="#EAEAEA" />
      <mask id="mask0_1035_3224" maskUnits="userSpaceOnUse" x="4" y="4" width="24" height="24">
        <rect x="4" y="4" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1035_3224)">
        <path d="M9 17V15H23V17H9Z" fill="black" />
      </g>
    </svg>
  );
};

export default SubtractCircle;
